import * as tslib_1 from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import * as common from 'relative-time-component';
export * from 'relative-time-component';
import { indexTemplateHtml, indexTemplateHtmlStatic } from './variables';
var RelativeTime = /** @class */ (function (_super) {
    tslib_1.__extends(RelativeTime, _super);
    function RelativeTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isHovering = false;
        _this.forceUpdateFlag = false;
        return _this;
    }
    Object.defineProperty(RelativeTime.prototype, "title", {
        get: function () {
            return common.format(this.time);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RelativeTime.prototype, "relativeTime", {
        get: function () {
            return common.getRelativeTime(this.time, this.locale, this.forceUpdateFlag);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RelativeTime.prototype, "timeText", {
        get: function () {
            return this.isHovering ? this.title : this.relativeTime;
        },
        enumerable: true,
        configurable: true
    });
    RelativeTime.prototype.beforeMount = function () {
        var _this = this;
        this.timer = setInterval(function () {
            _this.forceUpdateFlag = !_this.forceUpdateFlag;
        }, 60 * 1000);
    };
    RelativeTime.prototype.beforeDestroy = function () {
        if (this.timer) {
            clearInterval(this.timer);
        }
    };
    RelativeTime.prototype.mouseenter = function () {
        this.isHovering = true;
    };
    RelativeTime.prototype.mouseleave = function () {
        this.isHovering = false;
    };
    RelativeTime = tslib_1.__decorate([
        Component({
            render: indexTemplateHtml,
            staticRenderFns: indexTemplateHtmlStatic,
            props: ['time', 'locale']
        })
    ], RelativeTime);
    return RelativeTime;
}(Vue));
export { RelativeTime };
Vue.component('relative-time', RelativeTime);



//////////////////
// WEBPACK FOOTER
// ./node_modules/relative-time-vue-component/dist/index.js
// module id = null
// module chunks = 